import { CSSProperties, FC, ReactNode } from 'react';
import { TOKENS, SeverityLevel } from './tokens';

type Tone = SeverityLevel | 'neutral' | 'action';
type Size = 'xs' | 'sm';

type Props = {
  children: ReactNode;
  tone?: Tone;
  size?: Size;
  title?: string;
  onClick?: () => void;
};

// Pill-shaped tag used for severity counts, alarm types, protocol indicators,
// status flags. One component, many tones — keeps colors centralized.
export const Chip: FC<Props> = ({ children, tone = 'neutral', size = 'sm', title, onClick }) => {
  const palette = tone === 'neutral'
    ? { bg: TOKENS.color.surface, text: TOKENS.color.muted }
    : tone === 'action'
      ? { bg: TOKENS.color.actionSoft, text: TOKENS.color.action }
      : { bg: TOKENS.color.severity[tone].bg, text: TOKENS.color.severity[tone].text };

  const sizing: CSSProperties = size === 'xs'
    ? { fontSize: 10, padding: '2px 6px' }
    : { fontSize: 11, padding: '3px 8px' };

  return (
    <span
      title={title}
      onClick={onClick}
      style={{
        display: 'inline-block',
        background: palette.bg,
        color: palette.text,
        borderRadius: TOKENS.radius.chip,
        fontWeight: 600,
        lineHeight: 1.2,
        cursor: onClick ? 'pointer' : undefined,
        ...sizing,
      }}
    >
      {children}
    </span>
  );
};
